import { JobStatus } from '@core/generated/gql-types';

export const useJobUtils = () => {
  const getStatusBadgeClass = (status?: JobStatus) => {
    switch (status) {
      case JobStatus.Filled:
        return 'bg-green-100 text-green-800';
      case JobStatus.Unfilled:
        return 'bg-yellow-100 text-yellow-800';
      case JobStatus.Cancelled:
        return 'bg-red-100 text-red-800';
      case JobStatus.Completed:
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const formatEstimatedCost = (budget: number | undefined | null) => {
    if (!budget) return 'Not set';
    return `$${(budget / 100).toFixed(2)}`;
  };

  // Calculate margin percentage
  const calculateMargin = (
    clientPayRateCents: number | undefined | null,
    workerPayRateCents: number | undefined | null,
  ) => {
    if (!clientPayRateCents || !workerPayRateCents) {
      return null;
    }
    const clientRate = clientPayRateCents;
    const workerRate = workerPayRateCents;
    if (clientRate === 0) return null;
    const margin = ((clientRate - workerRate) / clientRate) * 100;
    return margin;
  };

  return {
    getStatusBadgeClass,
    formatEstimatedCost,
    calculateMargin,
  };
};
